import React from "react";
import PropTypes from 'prop-types';

export default class ProgressSpinnerSmall extends React.Component {
    render () {
        return (
            <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div> // all the divs are the bars in the spinner
        )
    }
}